/* HOST ITALIANO — Scroll reveal + scrolled state
   Mobile-optimised: usa IntersectionObserver, passive listeners, throttle via rAF.
   Caricato come module DOPO il bundle React. */
(function () {
  'use strict';

  // Rispetta preferenze utente per ridotte animazioni
  var prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) return;

  /* ---------- 1. Scrolled state per la navbar (cambia ombra/sfondo) ---------- */
  var body = document.body;
  var lastScroll = 0;
  var ticking = false;

  function onScroll() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (y > 8) body.classList.add('scrolled');
    else body.classList.remove('scrolled');
    lastScroll = y;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );

  /* ---------- 2. Scroll-reveal con IntersectionObserver ----------
     Applica .hi-reveal a tutte le section / card grandi quando il
     bundle React ha terminato il primo render, poi le rivela appena
     entrano nel viewport. */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hi-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08,
      }
    );

    // Selettori: sezioni della landing che meritano un fade-up al primo scroll
    var selectors = [
      '#root > div > section',
      '#root [class*="why-hosts"]',
      '#root [class*="product-features"]',
      '#root [class*="bundle-contents"]',
      '#root [class*="how-it-works"]',
      '#root [class*="testimonials"]',
      '#root [class*="faq"]',
      '#root [class*="reviews"]',
      '#root [class*="ugc"]',
      '#root [class*="stats"]',
      '#root [class*="offer"]',
      '#root [class*="poster"]',
    ];

    var nodes = document.querySelectorAll(selectors.join(','));
    nodes.forEach(function (el) {
      // Evita doppio reveal
      if (el.classList.contains('hi-reveal')) return;
      el.classList.add('hi-reveal');
      io.observe(el);
    });
  }

  // Il bundle React monta dentro #root in modo async; aspettiamo il primo paint
  // e poi facciamo un re-scan ogni 600ms per ~3s per catturare anche i componenti
  // che si renderizzano dopo (es. carosello UGC lazy).
  function bootReveal() {
    initReveal();
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      initReveal();
      if (attempts >= 5) clearInterval(iv);
    }, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootReveal);
  } else {
    bootReveal();
  }
})();

/* HOST ITALIANO — Autoplay marquee su MOBILE (continuo, senza pausa)
   Il bundle React fa scorrere i caroselli solo su desktop. Qui li
   facciamo scorrere anche su mobile, in continuo, su TUTTI i marquee
   (ota-marquee loghi piattaforme + ugc-marquee screen). Scope separato. */
(function () {
  'use strict';

  // Nota: il marquee gira anche con "riduci movimento" attivo, per scelta esplicita.
  // Solo schermi piccoli: su desktop ci pensa già il bundle React
  var isMobile =
    window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  if (!isMobile) return;

  var SPEED = 0.45; // px per frame (~27px/s). Alza/abbassa per regolare la velocità.

  function startMarquee(track) {
    if (!track || track.__hiAutoplay) return;
    track.__hiAutoplay = true;

    function tick() {
      if (!document.body.contains(track)) {
        track.__hiAutoplay = false;
        return; // il nodo è stato smontato: stop
      }
      if (!document.hidden) {
        var max = track.scrollWidth - track.clientWidth;
        if (max > 4) {
          if (track.scrollLeft >= max - 1) track.scrollLeft = 0;
          else track.scrollLeft += SPEED;
        }
      }
      window.requestAnimationFrame(tick);
    }
    window.requestAnimationFrame(tick);
  }

  function findScroller(el) {
    function ok(n) {
      if (n.scrollWidth - n.clientWidth <= 4) return false;
      var ox = window.getComputedStyle(n).overflowX;
      return ox === 'auto' || ox === 'scroll' || ox === 'hidden';
    }
    if (ok(el)) return el;
    var kids = el.querySelectorAll('*');
    for (var i = 0; i < kids.length; i++) {
      if (ok(kids[i])) return kids[i];
    }
    return null;
  }

  function boot() {
    var nodes = document.querySelectorAll('[class*="marquee"]');
    for (var i = 0; i < nodes.length; i++) {
      var t = findScroller(nodes[i]);
      if (t) startMarquee(t);
    }
  }

  // Il carosello si monta in modo async: ritenta per qualche secondo.
  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    boot();
    if (tries >= 8) clearInterval(iv);
  }, 700);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* HOST ITALIANO — Viewed Product per Klaviyo (browse abandonment)
   La landing è una SPA su "/": Shopify non emette un product_viewed nativo,
   quindi lo inviamo noi via klaviyo.push (coda sicura, drenata da klaviyo.js
   quando l'app embed Klaviyo è attivo). Nessun effetto se l'embed è spento. */
(function () {
  'use strict';
  window.klaviyo = window.klaviyo || [];
  var cfg = window.__SHOPIFY_THEME__ || {};
  var handle = cfg.productHandle || 'welcomebook-pro-kit';
  var fired = false;

  function fireViewedProduct() {
    if (fired) return;
    fired = true;
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var price = (p.price || 0) / 100;
        var compare = p.compare_at_price ? p.compare_at_price / 100 : price;
        var img = p.featured_image
          ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image)
          : '';
        var item = {
          ProductName: p.title,
          ProductID: String(p.id),
          Categories: p.type ? [p.type] : [],
          ImageURL: img,
          URL: window.location.origin + '/products/' + handle,
          Brand: p.vendor || 'Host Italiano',
          Price: price,
          CompareAtPrice: compare
        };
        window.klaviyo.push(['track', 'Viewed Product', item]);
        window.klaviyo.push(['trackViewedItem', {
          Title: item.ProductName,
          ItemId: item.ProductID,
          Categories: item.Categories,
          ImageUrl: item.ImageURL,
          Url: item.URL,
          Metadata: { Brand: item.Brand, Price: item.Price, CompareAtPrice: item.CompareAtPrice }
        }]);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fireViewedProduct);
  } else {
    fireViewedProduct();
  }
})();

/* HOST ITALIANO — Carrello: quantità SEMPRE 1 (prodotto digitale, 1 licenza).
   Il bundle React aggiunge con /cart/add.js (che SOMMA): cliccando più volte
   il carrello accumulava 2-3 copie, senza modo di ridurle, e il checkout
   addebitava il doppio/triplo. Qui rendiamo l'aggiunta IDEMPOTENTE: ogni
   "Aggiungi al carrello" prima svuota il carrello e poi aggiunge esattamente 1.
   Negozio mono-prodotto: svuotare è sicuro. In più, al caricamento riportiamo
   a 1 un eventuale carrello già accumulato. Tocca SOLO /cart/add.js. */
(function () {
  'use strict';
  var orig = window.fetch;
  if (!orig) return;

  function forceQtyOne(init) {
    if (!init || !init.body || typeof init.body !== 'string') return init;
    var b = init.body, out = b;
    try {
      if (b.charAt(0) === '{' || b.charAt(0) === '[') {
        var o = JSON.parse(b);
        if (o && Array.isArray(o.items)) o.items.forEach(function (it) { it.quantity = 1; });
        else if (o) o.quantity = 1;
        out = JSON.stringify(o);
      } else if (b.indexOf('quantity=') !== -1) {
        out = b.replace(/quantity=\d+/g, 'quantity=1');
      }
    } catch (e) { return init; }
    var ni = {};
    for (var k in init) { if (Object.prototype.hasOwnProperty.call(init, k)) ni[k] = init[k]; }
    ni.body = out;
    return ni;
  }

  var queue = Promise.resolve();

  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    if (url.indexOf('/cart/add') !== -1) {
      var self = this;
      var run = queue.then(function () {
        return orig.call(self, '/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function () { return orig.call(self, input, forceQtyOne(init)); });
      });
      queue = run.then(function () {}, function () {});
      return run;
    }
    return orig.apply(this, arguments);
  };

  function clampOnLoad() {
    orig('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        var updates = {}, need = false;
        cart.items.forEach(function (it) { if (it.quantity !== 1) { updates[it.variant_id] = 1; need = true; } });
        if (need) {
          orig('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        }
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', clampOnLoad);
  else clampOnLoad();
})();
